import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import TransferForm from '../../components/transfer/TransferForm';
import Storage from '../../services/Storage';

export default function Transfer() {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (Storage.getLocalAccessToken() === null) {
      navigate('/signin', { replace: true })
    }
  }, [navigate])
  return (
    <TransferForm />
  );
}